module.exports = __webpack_public_path__ + "static/abstract3-c450af71d90ea5d064598d68c24d7154.jpg";